import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface sessionParticipantDatesTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: sessionParticipantDatesTableStateState = {
    TableState: JSON.stringify({
        sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
        },
        columns: {
            columnVisibilityModel: {
                attendance: true,
                registrationStatus: true,
                name: true,
                firstName: false,
                lastName: false,
                emailAddress: true,
                registrationDate: true,
                preferredLanguage: true,
                scheduledPreworkInvitation: true,
                actualPreworkInvitation: true,
                deadline: true,
                accessExpiration: true,
            },
        },
    }),
};

export const sessionParticipantDatesTableStateSlice = createSlice({
    name: "sessionParticipantDatesTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateSessionsParticipantDatesGridState: (state, action: PayloadAction<string | null>) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateSessionsParticipantDatesGridState } =
    sessionParticipantDatesTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const sessionParticipantDatesTableState = (state: RootState) => state;
export default sessionParticipantDatesTableStateSlice.reducer;
